module.exports = __webpack_public_path__ + "img/chronext-logo-white.15dd1b6d.svg";